export const drawerItemsMain = [
  {
    key: "WorkOrderPlanning",
    title: "workOrderPlanning",
    routes: [
      {
        nav: "WorkOrderPlanning",
        routeName: "WorkOrderPlanning",
        title: "workOrderPlanning",
      },
    ],
  },
];

if (process.env.NODE_ENV !== "production") {
  drawerItemsMain.push(
    {
      key: "Production Dashboard",
      title: "productionDashboard",
      routes: [
        {
          nav: "ScanDashboard",
          routeName: "ScanDashboard",
          title: "productionDashboard",
        },
      ],
    },
    {
      key: "ScanByManager",
      title: "scanResults",
      routes: [
        {
          nav: "ScanByManager",
          routeName: "ScanByManager",
          title: "scanResults",
        },
      ],
    },
  );
}
